module.exports = __webpack_public_path__ + "teqbahn-assets/media/9.23b78b09.png";